var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQualificationsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.646,
    height: 37.646,
    viewBox: "0 0 37.646 37.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "szakter\\xFCletek_-_fekete",
    transform: "translate(-1695.261 -395.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keres\\xE9s",
    transform: "translate(1714.475 414.715)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    cx: 6.462,
    cy: 6.462,
    r: 6.462,
    fill: "none",
    stroke: "#263d50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10814",
    d: "M1717.3,417.941l5.8,5.8Z",
    transform: "translate(-1706.573 -406.67)",
    fill: "none",
    stroke: "#263d50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    d: "M1717.89,414.439",
    transform: "translate(-1706.352 -407.985)",
    fill: "none",
    stroke: "#263d50",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    d: "M1731.907,419.82V408.889h-12.347V396.522h-10.931v12.367h-12.368V419.82h12.368v12.347h10.931",
    fill: "none",
    stroke: "#263d50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    d: "M1722.174,413.459",
    transform: "translate(9.733 6.362)",
    fill: "none",
    stroke: "#263d50",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualificationsBlack);
export default __webpack_public_path__ + "static/media/qualificationsBlack.3f181ede0132fffce273e0502b8683ed.svg";
export { ForwardRef as ReactComponent };